import '../../shared/error-boundary.ts';
/**
 * Tool page entry — data-url-decode
 */

import { urlDecode } from '@bytario/core/data/url-decode';
import { createProgress, yieldToPaint } from '../../shared/progress.ts';

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c]!);
}

function highlightEncoded(input: string): string {
  return input.replace(/((?:%[0-9A-Fa-f]{2})+|\+)/g, '<mark>$1</mark>');
}

const button = document.querySelector('#run') as HTMLButtonElement;
button.addEventListener('click', async () => {
  const input = (document.querySelector('#text') as HTMLTextAreaElement).value;
  if (!input) return;
  const p = createProgress('#result', ['Decoding', 'Complete']);
  try {
    p.activate(0);
    await yieldToPaint();
    const decoded = await urlDecode(new TextEncoder().encode(input));
    const output = typeof decoded === 'string' ? decoded : new TextDecoder().decode(decoded);
    p.complete(0);

    p.activate(1);
    p.complete(1);
    p.finish(
      '<div><h3>Original (encoded characters <mark>highlighted</mark>)</h3><pre class="wrap">' + highlightEncoded(escapeHtml(input)) + '</pre></div>' +
      '<div><h3>Decoded</h3><pre class="wrap">' + escapeHtml(output) + '</pre></div>'
    );
  } catch (e) {
    p.error(String(e));
  }
});
